import Sidebar from '@rio-cloud/rio-uikit/Sidebar';
import { useCallback, useState } from 'react';

import type { ChargingSessionType } from '@/api/schema';
import ChargingDetails from '@/features/chargingActivity/components/Sidebar/ChargingDetails';
import { t } from '@/lib/utils';

interface ChargingSessionSidebarProps {
    open: boolean;
    dismiss: () => void;
    session?: ChargingSessionType;
}

const ChargingSessionSidebar = ({ open, dismiss, session }: ChargingSessionSidebarProps) => {
    const [dialog] = useState(false);

    const handleClose = useCallback(() => {
        if (!dialog) {
            dismiss();
        }
    }, [dialog, dismiss]);

    const header = (
        <div className='margin-top-5 margin-left-5 margin-bottom-20'>
            <span>{t('chargingSessions.chargingSessionDetail')}</span>
            <div className='text-normal text-size-14 margin-top-20'>
                {t('chargingSessions.sessionId')}: {session?.sessionId}
            </div>
        </div>
    );

    return (
        <Sidebar
            showHeaderBorder
            title={header}
            titleClassName='margin-bottom-20'
            closed={!open}
            onClose={handleClose}
            bodyClassName='padding-x-15 margin-top-25'
            position={Sidebar.RIGHT}
            hasBackdrop={true}
            onBackdropClick={handleClose}
            width={450}
            fly
        >
            {open && <ChargingDetails state={session} />}
        </Sidebar>
    );
};

export default ChargingSessionSidebar;
